export type StoreHookNonReactive<S extends object> = <
  T extends readonly (keyof S)[],
>(
  fields: T
) => Pick<S, T[number]>;

/** Store hook factory
 * @param store - store that we want a hook for
 * @returns - hook that directly accesses the store state without reactivity
 */
export const createStoreHookNonReactive =
  <S extends object>(Store: { get: () => S }): StoreHookNonReactive<S> =>
  <T extends readonly (keyof S)[]>(_fields: T) => {
    return Store.get();
  };
